import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageModalComponent } from '../components/image-modal.component';

@Directive({
    selector: '[viewImage]',
})
export class ImageViewerDirective implements OnInit, OnDestroy {
    @Input("viewImage") imageSrc: string = "";
    @Input("viewImageEvent") event: "click" | "dblclick" | "hover" = "click";
    @Input("alt") alternateText: string = "IMAGE PREVIEW";

    private htmlElement: HTMLElement;

    constructor(
        public el: ElementRef,
        private modalService: NgbModal,
    ) {
        this.htmlElement = el.nativeElement;
    }

    ngOnInit() {
        console.log("initiate ImageViewerDirective for..", this.htmlElement);
        if (!!!this.imageSrc) {
            console.log("imageSrc is empty. Deactivating ImageViewerDirective");
            return;
        }

        this.htmlElement.classList.add("hasImageViewer");

        if (this.isHover) {
            this.htmlElement.addEventListener("onmouseover", () => this.showImage());
            this.htmlElement.addEventListener("onmouseout", () => this.hideImage());
        } else {
            this.htmlElement.addEventListener(this.event, () => this.showImage());
        }
    }

    showImage() {
        if (this.isHover) {
        } else {
            const modalRef = this.modalService.open(ImageModalComponent, { size: 'lg', centered: true });
            modalRef.componentInstance.src = this.imageSrc;
            modalRef.componentInstance.alt = this.alternateText;
        }
    }

    hideImage() {
    }

    ngOnDestroy() {
        if (this.isHover) {
            this.htmlElement.removeEventListener("onmouseover", this.showImage);
            this.htmlElement.removeEventListener("onmouseout", this.hideImage);
        } else {
            this.htmlElement.removeEventListener(this.event, this.showImage);
        }
    }

    private get isHover() {
        return (this.event === "hover");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/image-viewer.directive.ts